var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    clipPath: "url(#clip0_1415_2096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 13.75C9.8543 13.75 9.20859 13.5382 8.65781 13.109L0.5 6.76562V15.625C0.5 16.6602 1.33945 17.5 2.375 17.5H18.625C19.6605 17.5 20.5 16.6605 20.5 15.625V6.76562L12.3438 13.1133C11.793 13.5391 11.1445 13.75 10.5 13.75ZM1.13633 5.67578L9.42539 12.125C10.0578 12.6172 10.9437 12.6172 11.5762 12.125L19.8652 5.67578C20.2305 5.36328 20.5 4.88281 20.5 4.375C20.5 3.33945 19.6602 2.5 18.625 2.5H2.375C1.33945 2.5 0.5 3.33945 0.5 4.375C0.5 4.88281 0.734766 5.36328 1.13633 5.67578Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1415_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeSvg);
export default __webpack_public_path__ + "static/media/EnvelopeSvg.95be9db1d105831379136d325d1f1708.svg";
export { ForwardRef as ReactComponent };